import { useState, useEffect } from 'react'
import { postsService, Post, ListPostsParams } from '@/services/postsService'

interface UseBlogReturn {
  posts: Post[]
  loading: boolean
  error: string | null
  searchQuery: string
  setSearchQuery: (query: string) => void
  refresh: () => void
  displayedCount: number
  loadMore: () => void
  hasMore: boolean
  totalResults: number
}

export function useBlog(): UseBlogReturn {
  const [posts, setPosts] = useState<Post[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [searchQuery, setSearchQuery] = useState('')
  const [displayedCount, setDisplayedCount] = useState(9)

  const fetchPosts = async () => {
    try {
      setLoading(true)
      setError(null)
      
      const params: ListPostsParams = {
        status: 'published',
        limit: 50
      }
      
      const response = await postsService.listPosts(params)
      setPosts(response.data || [])
    } catch (err) {
      setError('Erro ao carregar posts')
      console.error('Blog error:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPosts()
  }, [])

  const filteredPosts = posts.filter(post =>
    post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (post.summary && post.summary.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (post.content && post.content.toLowerCase().includes(searchQuery.toLowerCase()))
  )

  const displayedPosts = filteredPosts.slice(0, displayedCount)
  const hasMore = filteredPosts.length > displayedCount

  const loadMore = () => {
    setDisplayedCount(prev => Math.min(prev + 6, filteredPosts.length))
  }

  return {
    posts: displayedPosts,
    loading,
    error,
    searchQuery,
    setSearchQuery,
    refresh: fetchPosts,
    displayedCount,
    loadMore,
    hasMore,
    totalResults: filteredPosts.length,
  }
}
